import { useLoanAgreements } from "../../../services/hooks/getApi";
import { FaDownload } from 'react-icons/fa';
import { GrDocumentText } from "react-icons/gr";
import { ShimmerThumbnail } from "react-shimmer-effects";

const AgreementTab = () => {
  const { data: allLoanAgreements, isLoading } = useLoanAgreements();

  console.log("All Loan Agreements:", allLoanAgreements);

  return (
    <>
      {isLoading ? (
        <div className="shimmer-container">
          <div className="shimmer-effect">
            <ShimmerThumbnail row={2} col={2} card frameHeight={1000} />
          </div>
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            gap: '20px',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '200px'
          }}
        >
          {allLoanAgreements?.data?.map((agreement, index) => (
            <div
              key={agreement._id}
              style={{
                border: '1px solid #ddd',
                borderLeft: '4px solid #b59f5b',
                borderRadius: '8px',
                padding: '16px',
                minWidth: '250px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                backgroundColor: '#f5f5f5',
              }}
            >
              <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                Agreement {index + 1}
              </div>
              <div style={{ fontSize: '12px', marginBottom: '16px', color: '#555', textAlign: 'center' }}>
                {/* Lendee Account: {agreement.LendeeAccountID}<br/> */}
                {/* Created By: {agreement.createdBy}<br/> */}
                Created At: {new Date(agreement.createdAt).toLocaleString()}
              </div>

              <div style={{ display: 'flex', gap: '40px', textAlign: 'center' }}>
                {/* View Button */}
                <a
                  href={agreement.officeViewUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="View"
                  style={{ color: '#b59f5b', fontSize: '20px', textDecoration: 'none' }}
                >
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <GrDocumentText size={20} />
                    <span style={{ marginTop: '8px', fontSize: '16px' }}>View</span>
                  </div>
                </a>

                {/* Download Button */}
                <a
                  href={agreement.docLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download"
                  style={{ color: '#28a745', fontSize: '20px', textDecoration: 'none' }}
                >
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <FaDownload size={20} />
                    <span style={{ marginTop: '8px', fontSize: '16px' }}>Download</span>
                  </div>
                </a>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default AgreementTab;
